export class Step3 {
    constructor() {}
    intitule = 'stepper.form.simp_re.step3';
    getcriteresattrib = 'form.simp_re.getcriteresattrib';

    getobjet = 'form.simp_re.getobjet';
    getspan2 = 'form.simp_re.getspan2';
    getspan3 = 'form.simp_re.getspan3';
    getspan4 = 'form.simp_re.getspan4';
    getspan5 = 'form.simp_re.getspan5';
    getnum = 'form.simp_re.getnum';
    gettypevoie = 'form.simp_re.gettypevoie';
    getnomvoie = 'form.simp_re.getnomvoie';
    getcp = 'form.simp_re.getcp';
    getville = 'form.simp_re.getville';
    getlieuexecutionlivraison = 'form.simp_re.getlieuexecutionlivraison';
    ajouter = 'boutons.ajouter';
    supprimer = 'boutons.supprimer';

}
